export default "__VITE_ASSET__D3cg4QUt__"